import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

const businessTypes = [
  "Sole Proprietorship",
  "Partnership",
  "LLC",
  "Corporation",
  "Nonprofit",
  "Other"
];

const industries = [
  "Retail",
  "Food & Beverage",
  "Healthcare",
  "Technology",
  "Manufacturing",
  "Construction",
  "Professional Services",
  "Education",
  "Real Estate",
  "Transportation",
  "Other"
];

const timeInBusinessOptions = [
  "Not Yet Started",
  "Less than 6 months",
  "6-12 months",
  "1-2 years",
  "2-5 years",
  "5+ years"
];

const BusinessInfoStep = ({ onNext, initialValue = {
  businessName: "",
  businessType: "",
  businessIndustry: "",
  timeInBusiness: ""
} }) => {
  const [formData, setFormData] = useState(initialValue);

  const isFormValid = () => {
    return formData.businessName && 
           formData.businessType && 
           formData.businessIndustry && 
           formData.timeInBusiness;
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="flex flex-col min-h-[400px] md:min-h-[450px]">
      <div className="space-y-3 mb-6">
        <div className="text-center space-y-1">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Tell us a little about your business</h2>
          <div className="w-12 h-0.5 bg-[#1a4a1a] mx-auto"></div>
        </div>
      </div>

      <div className="flex-grow space-y-6">
        <div className="space-y-2">
          <Label htmlFor="businessName" className="text-base text-gray-700">Business Name</Label>
          <Input
            id="businessName"
            value={formData.businessName}
            onChange={(e) => handleChange('businessName', e.target.value)}
            placeholder="Enter your business name"
            className="w-full text-base md:text-lg py-6"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="businessType" className="text-base text-gray-700">Business Type</Label>
          <Select
            value={formData.businessType}
            onValueChange={(value) => handleChange('businessType', value)}
          >
            <SelectTrigger id="businessType" className="w-full text-base md:text-lg py-6">
              <SelectValue placeholder="Select business type" />
            </SelectTrigger>
            <SelectContent>
              {businessTypes.map((type) => (
                <SelectItem
                  key={type}
                  value={type}
                  className="text-base cursor-pointer py-3 px-4"
                >
                  {type}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="businessIndustry" className="text-base text-gray-700">Industry</Label>
          <Select
            value={formData.businessIndustry}
            onValueChange={(value) => handleChange('businessIndustry', value)}
          >
            <SelectTrigger id="businessIndustry" className="w-full text-base md:text-lg py-6">
              <SelectValue placeholder="Select industry" />
            </SelectTrigger>
            <SelectContent>
              {industries.map((industry) => (
                <SelectItem
                  key={industry}
                  value={industry}
                  className="text-base cursor-pointer py-3 px-4"
                >
                  {industry}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="timeInBusiness" className="text-base text-gray-700">Time in Business</Label>
          <Select
            value={formData.timeInBusiness}
            onValueChange={(value) => handleChange('timeInBusiness', value)}
          >
            <SelectTrigger id="timeInBusiness" className="w-full text-base md:text-lg py-6">
              <SelectValue placeholder="Select time in business" />
            </SelectTrigger>
            <SelectContent>
              {timeInBusinessOptions.map((option) => (
                <SelectItem
                  key={option}
                  value={option}
                  className="text-base cursor-pointer py-3 px-4"
                >
                  {option}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <div className="mt-6">
        <Button
          onClick={() => onNext(formData)}
          disabled={!isFormValid()}
          className="w-full bg-[#1a4a1a] hover:bg-[#1a4a1a]/90 text-white py-3 md:py-4 text-base md:text-lg font-semibold rounded-lg shadow-md hover:shadow-lg transition-all"
        >
          Continue
        </Button>
      </div>
    </div>
  );
};

export default BusinessInfoStep; 